var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "h-100 position-relative" },
    [
      _c("Header", {
        attrs: { flagList: _vm.flagList, currentFlag: _vm.currentFlag },
        on: { flagChange: _vm.handleFlagChange },
        scopedSlots: _vm._u([
          {
            key: "header-right",
            fn: function() {
              return [_c("div", { attrs: { id: "product-news" } })]
            },
            proxy: true
          }
        ])
      }),
      _vm._t("default"),
      _c("Footer", {
        attrs: {
          countryCode: _vm.currentFlag
            ? _vm.currentFlag.countryCode.toLowerCase()
            : undefined
        }
      }),
      _c("DialogConfirmChangedCountry", {
        attrs: { isOpen: _vm.isSwitchCountryModal, closeOnClickOutside: false },
        on: {
          discard: _vm.handleDiscardChangedCountry,
          confirm: _vm.handleConfirmChangedCountry
        }
      }),
      _c("DialogSwitchToMobile", {
        attrs: {
          isOpen: _vm.isShowSwitchToMobileDialog,
          closeOnClickOutside: false
        },
        on: {
          discard: _vm.handleDiscardSwitchToMobile,
          confirm: _vm.handleConfirmSwitchToMobile
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }